<template>
  <div id="schedule_startList">
    <div class="group_container" ref="tableParentDom">
      <div
        v-show="eventCompModeDatas && !eventCompModeDatas.notData"
        class="group_box"
      >
        <EVENTCOP_MODE_4
          v-if="eventCompModeDatas"
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :sportsTypeArr="sportsTypeArr"
          :currSportsDetail="currSportsDetail"
          :datas="eventCompModeDatas"
          :axiosBaseUrl="axiosBaseUrl"
          :curTimeZoneItem="curTimeZoneItem"
          :sportCompetitionType="sportCompetitionType"
        ></EVENTCOP_MODE_4>
      </div>
      <cup_notData
        v-show="eventCompModeDatas && eventCompModeDatas.notData"
        className="relativePtb60"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import { https_scheduleDetail_startList } from '@api/platfrom_basketball_api'

import cup_base_data_mixin from '@mixins/cup_base_data'
import platfrom_refresh_data_mixin from '@mixins/platfrom_refresh_data'
import cup_notData from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_4 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_4.vue'

export default {
  name: 'schedule_startList',
  components: { cup_notData, EVENTCOP_MODE_4 },
  mixins: [cup_base_data_mixin, platfrom_refresh_data_mixin],
  props: {},
  data() {
    return {
      loading: false,
      tableMode: 'teamData',
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: 'playerDetailIndex',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      currSportsDetail: {},
      eventCompModeDatas: null,
      sportsTypeArr: ['combat', 'uncombat'],
    }
  },
  created() {
    this.query = this.$route.query
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      //   this.jumpRouterPathNames = {
      //     pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
      //     pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      //   }
      this.currSportsDetail = {
        sportsId: moduleRouteNameEn,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: this.query.mid,
      }
    }

    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug(
      'this.parentWidthPx:',
      this.$refs.tableParentDom.scrollHeight,
      this.sportCompetitionType
    )
  },
  computed: {
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getStartListData()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getStartListData() {
      await https_scheduleDetail_startList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        sid: this.currSid,
        matchId: this.query.mid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              console.debug('this.eventCompModeDatas:', res.data)
              if (
                !res.data ||
                (res.data &&
                  res.data.home &&
                  res.data.home.length === 0 &&
                  res.data.away &&
                  res.data.away.length === 0)
              ) {
                this.eventCompModeDatas = Object.assign(
                  { data: null },
                  {
                    notData: true,
                  }
                )
              } else {
                this.eventCompModeDatas = Object.assign(res.data, {
                  notData: false,
                })
              }
              //   if (
              //     this.isRefresh &&
              //     this.refreshCallbackHandle &&
              //     !this.setIntervalId
              //   ) {
              //     this.refreshCallbackHandle(this.refreshCallback)
              //   }
            } else {
              this.eventCompModeDatas = { notData: true }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#schedule_startList {
  .select_row_box {
    padding-top: 2.778vw;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .group_container {
    width: 100%;
    .group_box {
      padding: 1.388vw 0 2.778vw 0;
      .teamName {
        display: block;
        padding-bottom: 0.974vw;
        font-size: 1.25vw;
        font-weight: bold;
      }
    }

    .noDataClass {
      display: block;
      width: 100%;
      line-height: 5.55vw;
      text-align: center;
      font-size: 0.972vw;
      color: var(--mixtmt_greyColor2);
    }
    .noDataClass {
      border-top: 1px solid var(--mixtmt_greyColor0);
      border-bottom: 1px solid var(--mixtmt_greyColor0);
    }
  }
}
</style>
